export enum ScreenBreakpoint {
  MOBILE = 320,
  LANDSCAPE_MOBILE = 576,
  TABLET = 768,
  SMALL_DESKTOP = 992,
  DESKTOP = 1200,
  LARGE_DESKTOP = 1400,
  LARGER_DESKTOP = 1800,
}

export function determineScreenBreakpoint(width: number): ScreenBreakpoint {
  if (width < ScreenBreakpoint.MOBILE) {
    return ScreenBreakpoint.MOBILE;
  } else if (width < ScreenBreakpoint.LANDSCAPE_MOBILE) {
    return ScreenBreakpoint.LANDSCAPE_MOBILE;
  } else if (width < ScreenBreakpoint.TABLET) {
    return ScreenBreakpoint.TABLET;
  } else if (width < ScreenBreakpoint.SMALL_DESKTOP) {
    return ScreenBreakpoint.SMALL_DESKTOP;
  } else if (width < ScreenBreakpoint.DESKTOP) {
    return ScreenBreakpoint.DESKTOP;
  } else if (width < ScreenBreakpoint.LARGE_DESKTOP) {
    return ScreenBreakpoint.LARGE_DESKTOP;
  }

  return ScreenBreakpoint.LARGER_DESKTOP;
}
